















import { defineComponent, PropType } from '@vue/composition-api';
import { Field } from '@/components/Form';

export default defineComponent({
    name: 'Label',
    components: {
        KTField: Field,
    },
    props: {
        label: String,
        name: String,
        component: String,
        dependencies: {
            type: Array as PropType<string[]>,
            default: () => [],
        },
        rules: {
            type: [Array, Object],
            default: () => [],
        },
    },
    setup() {
        return {};
    },
});
